//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'IdealWeight_dailyEnergy',
  data () {
    return {
      form: {
        data1: '',
        data2: ''
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        let Katz = form.data1 - 105
        let Hillier = Katz * form.data2
        self.hasScore = true
        return {
          csc_Katz: Katz.toFixed(2),
          csc_Hillier: Hillier.toFixed(2)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/IdealWeight_dailyEnergy.vue